import React from 'react';
import {
  SUBSCRIBE_CANCEL_LEAD,
  subscribeButtonLabel,
  subscribeChargeSentence,
  subscribeCheckboxPlain,
  subscribeOffer,
  subscribeRefundSentence,
  trialButtonLabel,
  trialChargeSentence,
  trialCheckboxPlain,
  trialLead,
  trialOffer,
  trialRefundSentence,
} from '../shared/consentCopy';

const linkStyle = {
  color: '#0f766e',
  fontWeight: 650,
};

/**
 * Auto-renewal disclosure. The same sentences render at phone and desktop width.
 */
export default function TrialConsentNotice({
  planName = 'solo',
  agents = 1,
  addon = 'none',
  profile = null,
  now,
  checked,
  onChange,
  colors = {},
}) {
  const offer = trialOffer({ planName, agents, addon, profile, now });
  const text = colors.text || '#111';
  return (
    <div style={{ textAlign: 'left', color: text, fontSize: '1rem', lineHeight: 1.45 }}>
      <p style={{ margin: '0 0 0.75rem' }}>
        <strong>{trialLead(offer)}</strong>
        {' '}
        <strong>{trialChargeSentence(offer)}</strong>
        {' '}
        We'll email you reminders <strong>5 days and 1 day before</strong> your first charge.{' '}
        <strong>Cancel anytime online in Settings → Subscription & Billing.</strong>
        {` You won't be charged if you cancel before ${offer.trialEndLabel}. ${trialRefundSentence()} `}
        <a href="/trial-terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>Auto-Renewal Terms</a>
        {' · '}
        <a href="/refunds" target="_blank" rel="noopener noreferrer" style={linkStyle}>Refund & Cancellation Policy</a>
        {' · '}
        <a href="/terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>Terms of Service</a>
      </p>
      <label style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
        <input
          type="checkbox"
          checked={checked === true}
          onChange={(event) => onChange(event.target.checked)}
          style={{ marginTop: '0.2rem', width: '1.1rem', height: '1.1rem', flexShrink: 0 }}
        />
        <span>{trialCheckboxPlain(offer)}</span>
      </label>
    </div>
  );
}

export function trialButtonFor({ planName, agents, addon, profile, now }) {
  return trialButtonLabel(trialOffer({ planName, agents, addon, profile, now }));
}

/**
 * Charge-today auto-renewal disclosure. Same sentences at phone and desktop width.
 */
export function SubscribeConsentNotice({
  planName = 'solo',
  agents = 1,
  addon = 'none',
  refundVariant = 'prior_charge',
  checked,
  onChange,
  colors = {},
}) {
  const offer = subscribeOffer({ planName, agents, addon });
  const text = colors.text || '#111';
  return (
    <div style={{ textAlign: 'left', color: text, fontSize: '1rem', lineHeight: 1.45 }}>
      <p style={{ margin: '0 0 0.75rem' }}>
        <strong>{subscribeChargeSentence(offer)}</strong>
        {' '}
        <strong>{SUBSCRIBE_CANCEL_LEAD}</strong>
        {' '}
        {subscribeRefundSentence(refundVariant)}
        {' '}
        <a href="/trial-terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>Auto-Renewal Terms</a>
        {' · '}
        <a href="/refunds" target="_blank" rel="noopener noreferrer" style={linkStyle}>Refund & Cancellation Policy</a>
        {' · '}
        <a href="/terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>Terms of Service</a>
      </p>
      <label style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
        <input
          type="checkbox"
          checked={checked === true}
          onChange={(event) => onChange(event.target.checked)}
          style={{ marginTop: '0.2rem', width: '1.1rem', height: '1.1rem', flexShrink: 0 }}
        />
        <span>{subscribeCheckboxPlain(offer)}</span>
      </label>
    </div>
  );
}

export function subscribeButtonFor({ planName, agents, addon }) {
  return subscribeButtonLabel(subscribeOffer({ planName, agents, addon }));
}
